/* eslint-disable */
export const isString = (input) => {
  return typeof input === 'string';
};
